var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#021235",
    height: 19.952,
    rx: 2,
    width: 19.952,
    y: 0.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.195 8.388v-2.66c-3.478-.148-3.59-3.308-3.59-3.605v-.022h-2.687v10.362c0 .918-.59 1.733-1.462 2.02-.872.288-1.83-.017-2.377-.755s-.558-1.743-.028-2.494c.53-.75 1.48-1.076 2.359-.809v-2.744c-.206-.026-.413-.04-.621-.04-2.663 0-4.822 2.16-4.822 4.822 0 2.663 2.16 4.821 4.822 4.821 2.663 0 4.821-2.158 4.821-4.821 0-.068 0-.135-.004-.201v-5.103c1.237 1.132 3.59 1.229 3.59 1.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.987 9.044v-2.662c-3.478-.147-3.59-3.307-3.59-3.604v-.022h-2.687v10.362c0 .918-.59 1.733-1.462 2.02-.872.288-1.83-.016-2.377-.754s-.558-1.744-.029-2.494c.53-.75 1.48-1.077 2.36-.81v-2.743c-.207-.026-.415-.038-.623-.038-1.95 0-3.708 1.176-4.454 2.978-.745 1.802-.332 3.876 1.047 5.254 1.38 1.379 3.454 1.79 5.255 1.044 1.802-.747 2.976-2.506 2.975-4.456 0-.068 0-.135-.005-.201v-5.104c1.238 1.132 3.59 1.23 3.59 1.23z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.672 2.756c.13.706.508 1.809 1.612 2.455-.843-.983-.886-2.25-.886-2.433v-.022zm4.315 6.288v-2.662c-.266-.01-.531-.04-.793-.093v2.096s-2.353-.097-3.59-1.23v5.102c.003.067.005.134.005.201 0 1.778-.978 3.41-2.545 4.25-1.566.84-3.468.749-4.947-.236 1.366 1.411 3.452 1.852 5.272 1.115s3.012-2.505 3.012-4.47c0-.067 0-.134-.005-.2v-5.103c1.238 1.132 3.59 1.23 3.59 1.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.409 10.421c-1.065-.325-2.2.225-2.605 1.261-.406 1.037.055 2.21 1.058 2.695-.542-.74-.55-1.744-.019-2.491.53-.748 1.48-1.072 2.357-.805v-2.745c-.206-.026-.414-.038-.622-.038-.057 0-.114 0-.17.004v2.119z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreTiktok);
export default __webpack_public_path__ + "static/media/store-tiktok.b8d24bb6b17b56810b367aeb05201062.svg";
export { ForwardRef as ReactComponent };